export default __webpack_public_path__ + "static/media/cardsEDP.f787376b.png";